import { ColorResult, SketchPicker } from 'react-color'
import React from 'react'
import { Card } from '@mui/joy'

type ColorPickerProps = {
  pickedColor: string | undefined
  setPickedColor: (color: string) => void
  changeCompleted: (color: string) => void
}

function ColorPicker(props: ColorPickerProps) {
  const handleChangeComplete = (color: ColorResult) => {
    props.setPickedColor(color.hex)
    props.changeCompleted(color.hex)
  }

  return (
    <Card variant="soft" sx={{ mt: -2 }}>
      <SketchPicker
        styles={{
          picker: {},
        }}
        disableAlpha
        color={props.pickedColor}
        onChangeComplete={handleChangeComplete}
      />
    </Card>
  )
}

export default ColorPicker
